export function getFrameDimensions(frameModel, frame) {
    return {
        width: Math.round(
            2 * frame.physicalDimensions?.borderWidth 
            + 2 * frame.physicalDimensions?.matPadding
            + frameModel.length * frame.physicalDimensions?.letterWidth
            + (frameModel.length - 1) * frame.physicalDimensions?.letterSpacing
        ),
        height: Math.round(
            2 * frame.physicalDimensions?.borderWidth 
            + 2 * frame.physicalDimensions?.matPadding
            + frame.physicalDimensions?.letterHeight
        ) 
    }
}

export function isTouchDevice(){
    var hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
        hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
        var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        } else if ('orientation' in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            var UA = navigator.userAgent;
            hasTouchScreen = (
                /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
            );
        }
    }
    return hasTouchScreen
}

export const qrMap = [
    {
        id: "moszkva", hash: "#bTJ8bzZ8czF8ejJ8azN8djZ8YTEzd19tb2Rlcm5fYmxhY2tfbWF0LWdyZXk="
    },
     {
        id: "corvin", hash: "#YzN8bzJ8cjF8djN8aTR8bjFfbW9kZXJuX2JsYWNrX21hdC1ncmV5"
    },
    {
        id: 'kalvin', hash: '#azZ8YTJ8bDh8djEyfGk1fG4xX21vZGVybl9ibGFja19tYXQtZ3JleQ=='
    },
    {
        id: 'blaha', hash: '#YjR8bDR8YTR8aDF3fGExNV9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk='
    },
    {
        id: 'astoria', hash: '#YTd8czF8dDd8bzZ3fHIxfGk4fGExMF9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk='
    },
    {
        id: 'fovam', hash: '#ZjF8bzN8djFjfGEzfG0xX21vZGVybl9ibGFja19tYXQtZ3JleQ=='
    },
    {
        id: 'nyugati', hash: '#bjF8eTN8dTN8ZzJ8YTExfHQxMHxpMl9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk='
    },
    {
        id: 'moricz', hash: '#bTEwfG80fHI1fGk3fGMxfHoxX21vZGVybl9ibGFja19tYXQtZ3JleQ=='
    },
    {
        id: 'gellert', hash: '#ZzJ8ZTF8bDh8bDR8ZTR8cjd8dDhfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'deak', hash: '#ZDd8ZTV8YTV8azRfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'oktogon', hash: '#bzF8azhjfHQ5d3xvOHxnM3xvN3xuMmNfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'toldi', hash: '#dDZ8bzNjfGw1fGQ1fGk3X21vZGVybl9ibGFja19tYXQtZ3JleQ=='
    },
    {
        id: 'keleti', hash: '#azN8ZTEwY3xsMXxlMXx0MTF8aTNfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'bp1', hash: '#YjZjfHUzfGQyfGExM3d8cDd8ZTV8czN8dDJfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'bp2', hash: '#YjZjfHUxfGQ0fGExNXxwNHxlNHxzMXx0MTBfbW9kZXJuX2JsYWNrX21hdC1ncmV5'
    },
    {
        id: 'vienna', hash: '#djN8aTR8ZTR8bjF8bjJ8YTExX21vZGVybl9ibGFja19tYXQtZ3JleQ=='
    },


    { id: 'buda', hash: '#Yjd8dTN8ZDl8YTl3X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'obuda', hash: '#bzd8Yjd8dTJ8ZDl8YTdfbW9kZXJuX2JsYWNrX21hdC1ncmV5' },
    { id: 'ujpest', hash: '#dTJ8ajJ8cDF8ZTJ8czN8dDRfbW9kZXJuX2JsYWNrX21hdC1ncmV5' },
    { id: 'margit', hash: '#bTl8YTEzd3xyNnxnMnxpNnd8dDd8czVjfHozfGkxfGczfGUxfHQxX21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'szlelek', hash: '#YjZjfHUzfGQyfGExM3d8cDd8ZTV8czN8dDJfbW9kZXJuX2JsYWNrX21hdC1ncmV5' },
    { id: 'bme1', hash: '#YjN8bTNjfGU4X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'bme2', hash: '#YjN8bTNjfGU4X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'bme3', hash: '#YjN8bTNjfGU4X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'elte1', hash: '#ZTF8bDhjfHQ3Y3xlM19tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'elte2', hash: '#ZTF8bDhjfHQ3Y3xlM19tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'boraros1', hash: '#YjV8bzJ8cjV8YTR8cjN8bzRjfHMzX21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'boraros2', hash: '#YjV8bzJ8cjV8YTR8cjN8bzRjfHMzX21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'koki1', hash: '#azF8bzNjfGs3d3xpMV9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'koki2', hash: '#azF8bzNjfGs3d3xpMV9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'nepliget', hash: '#bjF8ZTZ8cDN8bDN8aTd8ZzFjfGU3fHQ2X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'vagohid', hash: '#azF3fG8yfHoyfHYxY3xhNHxnMnxvM3xoM3xpNnd8ZDJfbW9kZXJuX2JsYWNrX21hdC1ncmV5' },
    { id: 'kelenfold', hash: '#azhjfGU4fGw0fGU1fG4yfGYxY3xvOHxsMXxkNl9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'deli', hash: '#ZDd8ZTR8bDVjfGk4X21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'arkad', hash: '#YTEzfHIxfGszfGEzfGQxX21vZGVybl9ibGFja19tYXQtZ3JleQ==' },
    { id: 'ferdinand', hash: '#ZjF8ZTF8cjdjfGQ4fGkzfG4xfGE4fG4yY3xkOV9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' },
    { id: 'peace', hash: '#cDR8ZTN8YTV8YzRjfGUzX21vZGVybl9ibGFja19tYXQtYmxhY2s=' },
    { id: 'jatszoter', hash: '#ajJ8YTE1fHQ3fHMzfHoyfG80fHQxMXxlNHxyN19tb2Rlcm5fYmxhY2tfbWF0LXdoaXRl' },
    { id: 'marc15', hash: '#YjZjfHUxfGQ0fGExNXxwNHxlNHxzMXx0MTBfbW9kZXJuX2JsYWNrX21hdC1ncmV5' },
    { id: 'insta', hash: '#aTh8bjJjfHM1Y3x0N3xhMTV8ZzJjfHI2fGExNHxtOF9tb2Rlcm5fYmxhY2tfbWF0LXdoaXRl' }
]